const CAROUSEL_ITEMS = [
  {
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20movie%20collage%20with%20warm%20golden%20lighting%2C%20film%20poster%20mood%2C%20Chinese%20historical%20drama%20atmosphere%2C%20elegant%20composition%2C%20professional%20cinema%20aesthetic%2C%20rich%20textures%2C%20dramatic%20shadows%2C%20warm%20amber%20tones&width=1200&height=600&seq=carousel-01&orientation=landscape',
    tag: '专题',
    title: '古装大剧观影指南',
    desc: '从经典到新作，盘点近年最值得看的古装电视剧。权谋、仙侠、宫斗、历史，每种类型都有精选推荐。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Science%20fiction%20movie%20scene%20with%20futuristic%20atmosphere%2C%20cinematic%20lighting%2C%20warm%20orange%20accents%2C%20professional%20film%20poster%20style%2C%20space%20aesthetic%2C%20dramatic%20composition%2C%20movie%20visual%20art&width=1200&height=600&seq=carousel-02&orientation=landscape',
    tag: '专题',
    title: '科幻电影宇宙全收录',
    desc: '从星际穿越到流浪地球，科幻迷的终极片单。硬核科幻、太空史诗、末日题材，高清呈现震撼视效。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Romantic%20comedy%20film%20scene%20with%20soft%20warm%20lighting%2C%20cinematic%20photography%2C%20cozy%20atmosphere%2C%20film%20poster%20aesthetic%2C%20gentle%20amber%20tones%2C%20emotional%20mood%2C%20professional%20movie%20visual&width=1200&height=600&seq=carousel-03&orientation=landscape',
    tag: '专题',
    title: '治愈系温暖影视特辑',
    desc: '温暖人心的电影与电视剧合集。家庭、友情、成长、梦想，这些作品如冬日暖阳，抚慰每一颗疲惫的心。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Suspense%20thriller%20film%20scene%20with%20dramatic%20lighting%2C%20cinematic%20composition%2C%20intense%20atmosphere%2C%20film%20poster%20style%2C%20warm%20and%20dark%20contrast%2C%20professional%20movie%20aesthetic%2C%20mystery%20mood&width=1200&height=600&seq=carousel-04&orientation=landscape',
    tag: '专题',
    title: '悬疑烧脑剧场',
    desc: '反转不断的悬疑佳作，让你从头到尾猜不到结局。烧脑剧情、精妙布局、震撼真相，一起走进迷雾重重的世界。',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 px-4 md:px-6">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading text-center mb-3">
          独家专题
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          深度策划的影视专题，发现更多观影灵感
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {CAROUSEL_ITEMS.map((item, i) => (
            <div
              key={i}
              className="bg-background-50 rounded-2xl overflow-hidden border border-background-200/60 group cursor-pointer"
            >
              <div className="relative h-52 md:h-60 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
                <div className="absolute bottom-4 left-4">
                  <span className="px-2.5 py-1 rounded-full bg-primary-500 text-background-50 text-xs font-medium">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-5">
                <h3 className="text-base font-semibold text-foreground-900 mb-2">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}